export const ActionType = {
  GET_CONTINENTS: 'GET_CONTINENTS',
};
